<template>
  <div>
    <h3>{{ $t('message.pmsl_command_demo') | title }}</h3>

    <b-form-row>
      <div class="col-4">
        <label class="label label-default">
          {{$t('message.pmsl_command_demo_client')}}
        </label>
      </div>
      <div class="col-4">
        <b-form-select v-model="params.client" :options="['linux', 'windows']"/>
      </div>
    </b-form-row>

    <b-form-row>
      <div class="col-4">
        <label class="label label-default">
          {{$t('message.pmsl_command_demo_target_type')}}
        </label>
      </div>
      <div class="col-4">
        <b-form-select v-model="params.target_type" :options="['linux', 'windows']"/>
      </div>
    </b-form-row>

    <b-form-row>
      <div class="col-4">
        <label class="label label-default">
          {{$t('message.pmsl_command_demo_target_name')}}
        </label>
      </div>
      <div class="col-4">
        <b-form-input v-model="params.target_name"/>
      </div>
    </b-form-row>

    <b-form-row>
      <div class="col-4">
        <label class="label label-default">
          {{$t('message.pmsl_command_demo_account_name')}}
        </label>
      </div>
      <div class="col-4">
        <b-form-input v-model="params.account_name"/>
      </div>
    </b-form-row>

    <b-form-row>
      <div class="col-4">
        <label class="label label-default">
          {{$t('message.pmsl_command_demo_credential_type')}}
        </label>
      </div>
      <div class="col-4">
        <b-form-select v-model="params.credential_type" :options="['password', 'private key']"/>
      </div>
    </b-form-row>

    <b-form-row>
      <div class="col-4">
        <label class="label label-default">
          {{$t('message.pmsl_command_demo_network_level_auth')}}
        </label>
      </div>
      <div class="col-4">
        <b-form-checkbox v-model="params.network_level_auth"/>
      </div>
    </b-form-row>

    <b-form-row>
      <div class="col-4">
        <label class="label label-default">
          {{$t('message.pmsl_command_demo_explicit_localhost')}}
        </label>
      </div>
      <div class="col-4">
        <b-form-checkbox v-model="params.explicit_localhost"/>
      </div>
    </b-form-row>

    <b-form-row>
      <div class="col-4">
        <label class="label label-default">
          {{$t('message.pmsl_command_demo_use_scb')}}
        </label>
      </div>
      <div class="col-4">
        <b-form-checkbox v-model="params.use_scb"/>
      </div>
    </b-form-row>

    <b-form-row v-if="params.use_scb">
      <div class="col-4">
        <label class="label label-default">
          {{$t('message.pmsl_command_demo_send_gateway_token')}}
        </label>
      </div>
      <div class="col-4">
        <b-form-checkbox v-model="params.send_gateway_token"/>
      </div>
    </b-form-row>

    <b-form-row v-if="params.use_scb">
      <div class="col-4">
        <label class="label label-default">
          {{$t('message.pmsl_command_demo_gateway_auth_enabled')}}
        </label>
      </div>
      <div class="col-4">
        <b-form-checkbox v-model="params.gateway_auth_enabled"/>
      </div>
    </b-form-row>

    <b-form-row v-if="params.use_scb">
      <div class="col-4">
        <label class="label label-default">
          {{$t('message.pmsl_command_demo_through_gateway')}}
        </label>
      </div>
      <div class="col-4">
        <b-form-input v-model="params.through_gateway"/>
      </div>
    </b-form-row>

    <b-form-row>
      <b-button class="padmin-button" @click="check" :disabled="checkDisabled">
        {{$t('message.pmsl_command_demo_check')}}
      </b-button>
    </b-form-row>


    <b-card v-if="command" :title="$t('message.pmsl_command_demo_command') | title">
      <b-card-text v-if="command" >
        {{command}}
      </b-card-text>
      <b-card-text v-if="command_note">
        {{command_note}}
      </b-card-text>
    </b-card>

  </div>
</template>

<script>
import { post } from "../http";

export default {
  name: "PmslCommandDemo",

  data() {
    return {
      params: {
        client: 'linux',
        target_type: 'linux',
        target_name: '',
        account_name: '',
        network_level_auth: false,
        explicit_localhost: false,
        credential_type: 'password',
        use_scb: false,
        send_gateway_token: false,
        gateway_auth_enabled: false,
        through_gateway: ''
      },
      command: '',
      command_note: ''
    }
  },

  computed: {
    checkDisabled() {
      return this.params.target_name.length == 0 || this.params.account_name.length == 0
    }
  },

  methods: {
    check() {
      this.command = ''
      this.command_note = ''
      post('/pmsl_command_demo', this.params, { "Content-Type": "application/json" }).then(
        resp => {
          this.command = resp.data.command
          this.command_note = resp.data.command_note
        },
        err => {
          console.log('err', err)
        }
      );
    },
  }
}
</script>
